import { record } from "fp-ts";

export interface Dictionary<T> {
  [index: string]: T;
}

export const toDictionaryByKey =
  <T>(key: (t: T) => string) =>
  (array: T[]) =>
    record.fromEntries(array.map((element) => [key(element), element]));
